import {
  LOAD_SUCCESS_PROVENANCES,
  LOAD_FAIL_PROVENANCES,
  SAVE_SUCCESS_PROVENANCES,
  SAVE_FAIL_PROVENANCES,
  UPDATE_SUCCESS_PROVENANCES,
  UPDATE_FAIL_PROVENANCES,
  DELETE_SUCCESS_PROVENANCES,
  DELETE_FAIL_PROVENANCES,
} from "../actions/provenanceAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_PROVENANCES:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_PROVENANCES:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_PROVENANCES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_PROVENANCES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_PROVENANCES:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.provenance_id === action.payload.provenance_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_PROVENANCES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_PROVENANCES:
      const filtered = state.data.filter((item) => {
        return item.provenance_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_PROVENANCES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
